<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
        :model="formData"
        ref="ruleForm"
        :rules="rules"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="场次" input-align="right" readonly>
              {{ formData.saiqu_name }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="单位"
              prop="danwei"
              :rules="[
                { required: true, message: '请输入单位名称', trigger: 'blur' },
              ]"
            >
              <el-input
                v-model="formData.danwei"
                type="text"
                placeholder="请输入单位名称"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="联系人"
              prop="ldname"
              :rules="[
                {
                  required: true,
                  message: '请输入联系人姓名',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="formData.ldname"
                placeholder="请输入联系人姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="手机"
              prop="phone"
              :rules="[
                {
                  required: true,
                  message: '请输入手机',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="formData.phone"
                placeholder="请输入手机"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="验证码"
              prop="phonecode"
              :rules="[
                {
                  required: true,
                  message: '请输入验证码',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                style="width:160px"
                v-model="formData.phonecode"
                placeholder="请输入验证码"
              ></el-input>
              <el-button @click="getCode"  size="small" type="primary" :disabled="clockSecond>0">{{clockSecond>0?
                    '('+clockSecond+'s)':'获取验证码'}}</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12"> 
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="邮箱"
              prop="email"
              :rules="[
                {
                  required: true,
                  message: '请输入邮箱',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="formData.email"
                placeholder="请输入邮箱"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="单位地区选择"
              prop="area"
              :rules="[
                {
                  required: true,
                  message: '请选择收件地区',
                  trigger: 'blur',
                },
              ]"
            >
              <el-cascader
                v-model="formData.area"
                ref="areas"
                @change="handleAreasChange"
                :options="areaOptions"
                :props="{ label: 'title' }"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="收件地区选择"
              prop="earea"
              :rules="[
                {
                  required: true,
                  message: '请选择收件地区',
                  trigger: 'blur',
                },
              ]"
            >
              <el-cascader
                v-model="formData.earea"
                ref="eareas"
                @change="handleEAreasChange"
                :options="areaOptions"
                :props="{ label: 'title' }"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="收件详细地址"
              prop="address"
            >
              <el-input
                type="text"
                placeholder="请输入详细地址"
                v-model="formData.address"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="footer-button">
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              :loading="saveLoading"
              >下一步
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>

      <LoginDialog
        :show="loginShow"
        @loginSuccess="loginSuccess"
        @loginCancel="loginCancel"
      />
    </div>
  </div>
</template>
<style scoped>
.box {
  width: 100%;
  margin: 0 auto;
}
.form {
  width: 1340px;
  min-height: 560px;
  background: #ffffff;
  padding-top: 24px;
  padding: 88px 0 30px 129px;
  box-sizing: border-box;
}
.savebtn {
  margin-top: 40px;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}
</style>
<script>
import Vue from "vue";
import validator from "../../../utils/validator";
import PicUploader from "@/components/picker/PicUploader.vue";

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Dialog,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
} from "vant";
import CaipanPicker from "@/components/picker/CaipanPicker.vue";
import JiaolianPicker from "@/components/picker/JiaolianPicker.vue";
import LoginDialog from "@/components/LoginDialog.vue";

Vue.use(Cell)
  .use(CellGroup)
  .use(Form)
  .use(Divider)
  .use(Area)
  .use(RadioGroup)
  .use(Dialog)
  .use(Radio)
  .use(Icon)
  .use(Toast)
  .use(Popup)
  .use(Picker)
  .use(Sidebar)
  .use(SidebarItem)
  .use(Tag)
  .use(Stepper)
  .use(Field)
  .use(Switch)
  .use(Button);
export default {
  name: "HuiyiApplyFormStep1",
  components: {
    [Field.name]: Field,
    PicUploader,
    CaipanPicker,
    JiaolianPicker,
    LoginDialog,
  },
  data: function () {
    return {
      arr: [],
      areaOptions: [],
      loginShow: false,
      saveLoading: false,
      saiqu_id: this.$route.query.saiqu_id,
      numTypeColumns: ["身份证", "护照"],
      showArea: false,
      areaList: {},
      areaValue: "",
      clockSecond:0,
      submitType: "",
      formData: {
        id: 0,
        area: "",
        earea: "",
        areas: [],
        eareas: [],
        saiqu_name: "",
        danwei: "",
        ldname: "",
        weixin: "",
        phone: "",
        email: "",
        province: "",
        city: "",
        county: "",
        eprovince: "",
        ecity: "",
        ecounty: "",
        address: "",
      },
      rules: {
        ldname: [{ required: true, message: "联系人不能为空" }],
        weixin: [{ required: true, message: "请输入微信号" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validator.phone, message: "请输入正确的手机号" },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: validator.email, message: "请输入正确的邮箱" },
        ],
        address: [{ required: true, message: "请输入详细地址" }],
      },
    };
  },
  filters: {},
  mounted() {
    let that = this;
    that.formData.id = this.$route.query.id;
    document.title = "联系人信息";
    this.fetch();
    this.getAreaOptions();
  },
  watch: {
    formData() {},
  },
  destroyed() {},
  methods: {
    getCode() {
        let that = this;
        if (that.clockSecond > 0) {
            return;
        }
        if (!that.formData.phone) {
            Toast('请输入手机号')
            return;
        }
        /*if (!that.formData.code) {
            Toast('请输入验证码')
            return;
        }*/
        that.$api.get('/api/index/phonecode', {phone: that.formData.phone}, (res) => {
            Toast(res.msg);
        })

        that.clockSecond = 60;

        var t = setInterval(function () {
            if (that.clockSecond > 0) {
                that.clockSecond = that.clockSecond - 1;
            } else {
                clearInterval(t);
            }
        }, 1000)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleChange(val) {
      console.log(val);
      for (var i = 0; i < this.arr.length; i++) {
        if (this.arr[i].value == val[0]) {
          this.formData.city = this.arr[i].title;
        }
        if (this.arr[i].value == val[1]) {
          this.formData.county = this.arr[i].title;
        }
        if (this.arr[i].value == val[2]) {
          this.formData.province = this.arr[i].title;
        }
      }
      this.formData.area = val[2];
    },
    getAreaOptions() {
      let that = this;
      that.$api.post("/api/utils/areaTree", {}, (res) => {
        that.areaOptions = res.data;
        that.namekeyList = res.data;
      });
    },
    handleAreasChange(values) {
      let data = this.$refs.areas.getCheckedNodes()[0].pathLabels;
      console.log("handleAreasChange", values, data);
      this.formData.area = values[2];
      this.formData.province = data[0];
      this.formData.city = data[1];
      this.formData.county = data[2];
    },
    handleEAreasChange(values) {
      let data = this.$refs.areas.getCheckedNodes()[0].pathLabels;
      console.log("handleEAreasChange", values, data);
      this.formData.earea = values[2];
      this.formData.eprovince = data[0];
      this.formData.ecity = data[1];
      this.formData.ecounty = data[2];
    },
    fetch() {
      let that = this;
      that.$api.get(
        "/api/huiyi/step1Detail",
        {
          saiqu_id: that.saiqu_id,
          id: that.formData.id,
        },
        (res) => { 
          that.formData = Object.assign(that.formData, res.data);

          console.log("Dialog");
          if (res.data.haveNoDone) {
            that
              .$confirm("建议您选择继续未完成的报名", "您有未完成的报名", {
                confirmButtonText: "继续未完成的报名",
                cancelButtonText: "重新报名",
                showClose: false,
                closeOnPressEscape: false,
                closeOnClickModal: false,
              })
              .then(() => {
                that.jumToOld();
              })
              .catch(() => {});
          }
        },
        (res) => {
          console.log("没有登录");
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    onQuestion() {
      console.log("onQuestion");
    },
    jumToOld(id) {
      rbLink(
        {
          name: "HuiyiApplyList",
        },
        "replace"
      );
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      // that.formData["area"] = that.formData.areas[2];

      console.log(that.formData, that.$refs[formName]);
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          console.log(that.formData);
          that.formValidate = true;
          for (let field in that.formData) {
            if (!this.formData.areas) {
              that.$message.warning("请选择地区");
              return;
            }
          }
          that.saveLoading = true;
          that.$api.post(
            "/api/huiyi/baoming",
            that.formData,
            (res) => {
              that.saveLoading = false;

              rbLink({
                name: "HuiyiApplyFormStep2",
                query: {
                  id: res.data.id,
                },
              });
            },
            (res) => {
              this.$message.warning(res.msg);
              that.saveLoading = false;
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    },
    submit(values) {
      this.submitType = "submit";
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// HuiyiApplyFormStep1.vue?7c19a02b